import React from "react";

import { Button, Grid, SvgIcon, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";

import TableHeaderFilter from "../../common/TableHeaderFilter/TableHeaderFilter";

import { useStyles } from "../../common/TableHeaderFilter/TableHeaderFilterStyles";
import { ReactComponent as closeButton } from "../../assets/svg/closeButton.svg";
import { isArrayValid, isEmptyOrNull, isUndefined } from "../../../utils/DataUtils";

import PolygonPOSZoneRecordView from "./PolygonPOSZoneRecordView";
import Loader from "../../common/Loader/Loader";

interface PlolygonServicesCardHeaderInterface {
  classes: any;
  handleFilterPopupOpen: any;
  handleFilterPopupClose: any;
  appFilterPopUpObj: any;
  headerRowCheckboxOnChange: any;
  handlePosZoneSearch: any;
  handlePosZoneSearchTextChange: any;
  currentCountry: any;
  handleResetPopUpOnClick: any;
  handleApplyPopUpOnClick: any;
  appStateObj: any;
  appliedServiceTypes: Array<string>;
}

const PlolygonServicesCardHeader = (props: PlolygonServicesCardHeaderInterface) => {
  const {
    classes,
    handleFilterPopupOpen,
    handleFilterPopupClose,
    appFilterPopUpObj,
    headerRowCheckboxOnChange,
    handlePosZoneSearch,
    handlePosZoneSearchTextChange,
    currentCountry,
    handleResetPopUpOnClick,
    handleApplyPopUpOnClick,
    appStateObj,
    appliedServiceTypes,
  } = props;

  const popUpClasses = useStyles();

  // Only render columns for the service types the currently-rendered data was fetched with (falls back to all before the first fetch completes)
  const visibleServiceHeaders = isArrayValid(appStateObj.polygonServiceListHeader)
    ? appStateObj.polygonServiceListHeader.filter(
      (serviceObject: any) => !isArrayValid(appliedServiceTypes) || appliedServiceTypes.includes(serviceObject?.name)
    )
    : [];

  const getPopUpViewContent = (popUpHeaderText: any) => {
    return (
      <Grid className={popUpClasses.popoverFilter} item>
        <Grid container className={popUpClasses.headerContainer}>
          <Typography className={popUpClasses.headerContainerSpanStyle}>{`${popUpHeaderText || "Filter List"}`}</Typography>
          <SvgIcon key={"Close_icon"} className={popUpClasses.closeIcon} component={closeButton} onClick={() => handleFilterPopupClose(appFilterPopUpObj.serviceType)} />
        </Grid>
        <Grid container className={popUpClasses.mainContainer}>
          {appFilterPopUpObj?.loading ? (
            <div className={popUpClasses.loaderDiv}>
              <Loader />
            </div>
          ) : (
            appFilterPopUpObj.openPopUp && (
              <PolygonPOSZoneRecordView
                classes={popUpClasses}
                appFilterPopUpObj={appFilterPopUpObj}
                headerRowCheckboxOnChange={headerRowCheckboxOnChange}
                handlePosZoneSearch={handlePosZoneSearch}
                handlePosZoneSearchTextChange={handlePosZoneSearchTextChange}
                currentCountry={currentCountry}
              />
            )
          )}
        </Grid>
        <Grid container className={popUpClasses.buttonsContainer}>
          <Button className={`${popUpClasses.button} ${popUpClasses.resetButtonStyle}`} onClick={() => handleResetPopUpOnClick(appFilterPopUpObj.serviceType)}>
            {"Reset"}
          </Button>
          <Button className={`${popUpClasses.button} ${popUpClasses.applyButtonStyle}`} onClick={() => handleApplyPopUpOnClick(appFilterPopUpObj.serviceType)}>
            {"Apply"}
          </Button>
        </Grid>
      </Grid>
    );
  };

  const getTableFilterView = (serviceType: any) => {
    return (
      <TableHeaderFilter
        openPopUp={appFilterPopUpObj.openPopUp}
        anchorEl={appFilterPopUpObj.anchorEl}
        handleFilterPopupOpen={(event: any) => handleFilterPopupOpen(event, serviceType)}
        handleFilterPopupClose={handleFilterPopupClose}
        popUpContent={getPopUpViewContent("POS - Zone List")}
        anchorName={serviceType}
      />
    );
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="none" size="small" align="left" className={`${classes.cellHeaderStyle} ${classes.cellPolygonIdHeaderStyle}`}>
          {`Polygon ID`}
        </TableCell>
        {isArrayValid(visibleServiceHeaders) &&
          visibleServiceHeaders.map((serviceObject: any, serviceObjectIndex: number) => (
            <TableCell padding="none" size="small" align="left" className={`${classes.cellHeaderStyle} ${classes.cellPolygonServiceStyle}`} key={`${serviceObjectIndex}-serviceObjectIndex-${serviceObject?.name}`}>
              {`${serviceObject?.displayName ?? serviceObject?.name ?? ""}`}
              {!isEmptyOrNull(appFilterPopUpObj?.filterList) && !isUndefined(appFilterPopUpObj.filterList[serviceObject?.name]) && isArrayValid(appFilterPopUpObj.filterList[serviceObject.name]) && (
                <span className={classes.filteredListSpanstyle}>{`${appFilterPopUpObj.filterList[serviceObject.name].length}`}</span>
              )}
              {getTableFilterView(serviceObject?.name ?? "")}
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
};

export default React.memo(PlolygonServicesCardHeader);
